import Dexie from "dexie";
import db from "../Db";

var DeleteConcessEtatEcheance = Dexie.async(function* () {
  yield db.open();
  yield db.CONCESS_ETAT_ECHEANCE.clear();
});

export default DeleteConcessEtatEcheance;
